import '@lottiefiles/lottie-player';

export default class LogoAnimation {
	constructor(player, area) {

        this.player = player;
        this.area = area;
        this.shouldStop = true;

        this.player.setSpeed(1.5);

        if (area.breakpoint.matches ) { // Portrait
            this.player.setSpeed(1.5);
        }

        this.running = false;
        this.ending = false;

        this.animation = this.player.getAttribute('data-anim');
        this.loopStart = this.player.getAttribute('data-loop-start');
        this.loopEnd = this.player.getAttribute('data-loop-end');

        this.player.addEventListener('play', (player) => {
            if(!this.running) {
                this.player.stop();
                this.player.seek(0);
            }
        });

        this.player.addEventListener('freeze', (player) => {
            const totalFrames = this.player.getLottie().totalFrames;
            this.player.seek(totalFrames);
        });


        this.player.addEventListener('frame', frame => {
            if(!this.running||this.ending) {
                return;
            }
            if (area.breakpoint.matches === false) { // Landscape
                if(frame.detail.frame>=this.loopEnd) {
                    if(!this.shouldStop) {
                        this.player.seek(this.loopStart);
                    } else {
                        this.ending = true;
                    }
                } else {
                    if(this.shouldStop) {
                        this.player.seek(this.loopEnd);
                    }
                }
            } else { // Portrait
                this.shouldStop = true;
                this.ending = true;
            }
        });

        this.player.addEventListener('complete', () => {
            area.finishedPlayer(this);
            this.running = false;
        });

	}

    start() {
        this.player.classList.add('is-playing');
        this.ending = false;
        this.shouldStop = false;
        this.running = true;

        setTimeout(() => {
            this.player.seek(0);
            this.player.play();
        }, 0);
    }

    setShouldStop(shouldStop) {
        if(!shouldStop&&this.ending) {
            return;
        }
        this.shouldStop = shouldStop;
    }

}